/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { sharedListPagesHeaderStyle } from "@monsma/App/WidgetExtensions/MyAccount/MyAccountListPagesExtension";
import { headerStyles } from "@monsma/Overrides/Widgets/OrderHistory/OrderHistoryHeader";

headerStyles.container = sharedListPagesHeaderStyle.container;

headerStyles.invoiceCountGridItem = sharedListPagesHeaderStyle.countGridItem;

headerStyles.toggleFilterGridItem = sharedListPagesHeaderStyle.toggleFilterGridItem;

headerStyles.toggleFilterButton = sharedListPagesHeaderStyle.toggleFilterButton;

headerStyles.toggleFilterButtonIcon = sharedListPagesHeaderStyle.toggleFilterButtonIcon;

headerStyles.headingText = sharedListPagesHeaderStyle.headingText;
